import { Box, Chip, Tab, Tabs, TabsProps } from "@mui/material";
import { ReactElement } from "react";
import Flex from "../Flex";
import Text from "../Text";
import { PRIMITIVE } from "../ds";

export type TabData = {
  value: string;
  label: string;
  icon?: string | ReactElement;
  count?: number;
  disabled?: boolean;
};

type CustomTabsProps = Omit<
  {
    tabsData: TabData[];
  } & TabsProps,
  "onChange"
> & {
  onChange: (value: string) => void;
};

const CustomTabs: React.FC<CustomTabsProps> = ({
  tabsData,
  onChange,
  ...others
}) => {
  return (
    <Box>
      <Tabs
        sx={{
          "&.MuiTabs-root": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "40px !important",
          },
          "& .MuiTabs-flexContainer": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "30px !important",
          },
          "& .MuiButtonBase-root": {
            padding: 0,
            minWidth: 0,
            marginRight: "20px",
          },
        }}
        scrollButtons={others?.scrollButtons ?? false}
        textColor={others.textColor ?? "primary"}
        indicatorColor={others.indicatorColor ?? "primary"}
        variant={others?.variant ?? "scrollable"}
        {...others}
      >
        {tabsData.map((tab) => (
          <Tab
            disabled={tab?.disabled}
            key={tab.value}
            label={
              <Flex gap={1} width={"100%"} alignItems={"center"}>
                <Text
                  fontWeight={"medium"}
                  fontSize={`${PRIMITIVE.typography.fontSize.body.b5}px !important`}
                >
                  {tab.label}
                </Text>

                <BadgeContent count={tab?.count ?? 0} />
              </Flex>
            }
            value={tab.value}
            icon={tab?.icon}
            iconPosition="start"
            onClick={() => onChange(tab.value)}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CustomTabs;

const BadgeContent = ({ count }: { count: number }) => {
  if (count === 0) return null;

  return (
    <Chip
      color="error"
      variant="filled"
      size="small"
      sx={{
        fontSize: "10px",
        padding: 0,
        height: "18px",
      }}
      label={count}
    />
  );
};
